import { useEffect, useState } from "react";
import { Zap, Flame, Sparkles } from "lucide-react";
import api from "@/lib/api";
import { Layout } from "@/components/Layout";
import { ProductCard } from "@/components/ProductCard";
import { useI18n } from "@/context/I18nContext";

export default function Zoomies() {
  const { t } = useI18n();
  const [flash, setFlash] = useState([]);
  const [trending, setTrending] = useState([]);

  useEffect(() => {
    api.get("/products?flash_sale=true").then((r) => setFlash(r.data)).catch(() => {});
    api.get("/products?sort=popular&limit=40").then((r) => setTrending(r.data)).catch(() =>
      api.get("/products?limit=40").then((r) => setTrending(r.data)));
  }, []);

  return (
    <Layout hideAd>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-testid="zoomies-page">
        {/* Hero strip */}
        <div className="rounded-2xl bg-gradient-to-r from-primary to-secondary text-white p-5 mb-5 flex items-center gap-3">
          <Sparkles className="w-8 h-8 shrink-0" />
          <div>
            <h1 className="font-display font-black text-2xl">Zoomies</h1>
            <p className="text-white/85 text-sm">Trending picks & flash deals, refreshed daily.</p>
          </div>
        </div>

        {flash.length > 0 && (
          <section className="mb-8" data-testid="zoomies-flash">
            <h2 className="font-display font-bold text-xl flex items-center gap-2 mb-4">
              <Zap className="w-6 h-6 text-destructive fill-destructive" /><span className="text-destructive">{t("flashSales")}</span>
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
              {flash.slice(0, 10).map((p, i) => <ProductCard key={p.product_id} product={p} index={i} />)}
            </div>
          </section>
        )}

        <section data-testid="zoomies-trending">
          <h2 className="font-display font-bold text-xl flex items-center gap-2 mb-4">
            <Flame className="w-6 h-6 text-secondary" /> Trending now
          </h2>
          {trending.length === 0 ? (
            <p className="text-sm text-muted-foreground py-10 text-center">No products yet.</p>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
              {trending.map((p, i) => <ProductCard key={p.product_id} product={p} index={i} />)}
            </div>
          )}
        </section>
      </div>
    </Layout>
  );
}
